// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DatapointTotalGroupExcelOptionFromJSON(json) {
    return {
        'datapointKeyName': json['datapointKeyName'],
        'datapointLabelName': !exists(json, 'datapointLabelName') ? undefined : json['datapointLabelName'],
    };
}
export function DatapointTotalGroupExcelOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'datapointKeyName': value.datapointKeyName,
        'datapointLabelName': value.datapointLabelName,
    };
}
